import { render } from "./LazyVideo.vue?vue&type=template&id=158c884b&scoped=true"
import script from "./LazyVideo.vue?vue&type=script&lang=js"
export * from "./LazyVideo.vue?vue&type=script&lang=js"

import "./LazyVideo.vue?vue&type=style&index=0&id=158c884b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158c884b"]])

export default __exports__